import { useEffect } from 'react';

import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { getDefaultDashboardVariant } from '@/modules/Dashboard/useDashboardVariant';
import { useAuth } from '@/providers/AuthProvider/AuthProvider';

export const Route = createFileRoute('/app/dashboard/')({
  component: DashboardIndexRoute,
});

/** `/app/dashboard` itself has no content — it just sends you to your default variant's route. */
function DashboardIndexRoute() {
  const { userData, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    const variant = getDefaultDashboardVariant(userData?.role, userData?.company.status);
    navigate({ to: `/app/dashboard/${variant}`, replace: true });
  }, [loading, userData, navigate]);

  return null;
}
